import React from "react";
import JobDetailView from "./JobDetailView";
import Gatekeeper from "./Gatekeeper";
import WithGetJobAlgolia from "../../common/components/WithGetJobAlgolia";

const JobDetailWrapper = ({ job, history, location }) => (
  <Gatekeeper {...{ job, history, location }}>
    <JobDetailView job={job} />
  </Gatekeeper>
);

export default () => <WithGetJobAlgolia Component={JobDetailWrapper} />;
